import { ExtractErrorDetails } from "./Errorservice";
import {
  ExtractSortBy,
  ExtractFilterBy,
  requestOptionsForGET,
  requestOptionsForPATCH,
  requestOptionsForDELETE,
  requestOptionsForPOST,
} from "./CommonServices";

const baseUrl = process.env.REACT_APP_APPHUB_API_ENDPOINT;

/* ── Read body as text first, then try JSON.parse.
   Calling res.json() directly on a plain-text error response throws
   "Unexpected token 'A'..." before we ever reach the !res.ok check. ── */
async function parseBody(res) {
  const text = await res.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return text; // plain-text response (e.g. "Access Code 'IDM11' already exists.")
  }
}

/* ── Turn a non-ok response into a rejection with a readable message.
   Falls back to the raw text string when body is not JSON (plain-text API errors). ── */
function rejectWith(res, body) {
  // body is a plain string (plain-text API error) → reject with it directly
  if (typeof body === "string") return Promise.reject(body);
  // body is a JSON object → use existing ExtractErrorDetails helper
  return Promise.reject(ExtractErrorDetails(res, body));
}

// ── List ─────────────────────────────────────────────────────────────────────
export const fetchIDMAccessCodeList = async (
  pageIndex = 1,
  pageSize  = 50,
  sorting   = [],
  filtering = []
) => {
  const sortstr   = !sorting   || sorting.length   === 0 ? "" : ExtractSortBy(sorting);
  const filterstr = !filtering || filtering.length === 0 ? "" : ExtractFilterBy(filtering);
  const querystr  = "?PageNumber=" + pageIndex + "&Limit=" + pageSize + sortstr + filterstr;
  const options   = requestOptionsForGET();

  return fetch(baseUrl + "IDMAccessCodes/" + querystr, options)
    .then(async (res) => {
      const body = await parseBody(res);
      if (!res.ok) return rejectWith(res, body);
      return body;
    })
    .catch((error) => {
      console.error("IDMAccessCode list fetch error:", error.toString());
    });
};

// ── Get by id ─────────────────────────────────────────────────────────────────
export const fetchIDMAccessCode = async (id) => {
  const options = requestOptionsForGET();
  return fetch(baseUrl + "idmaccesscodes/" + id, options).then(async (res) => {
    const body = await parseBody(res);
    if (!res.ok) return rejectWith(res, body);
    return body;
  });
};

// ── Create ───────────────────────────────────────────────────────────────────
export const postIDMAccessCode = async (data) => {
  const options = requestOptionsForPOST(data);
  return fetch(baseUrl + "idmaccesscodes", options).then(async (res) => {
    const body = await parseBody(res);
    if (!res.ok) return rejectWith(res, body);
    return body;
  });
};

// ── Update ───────────────────────────────────────────────────────────────────
export const patchIDMAccessCode = async (data) => {
  const options = requestOptionsForPATCH(data);
  return fetch(baseUrl + "idmaccesscodes/" + data.accesscodeid, options).then(
    async (res) => {
      const body = await parseBody(res);
      if (!res.ok) return rejectWith(res, body);
      return body;
    }
  );
};

// ── Delete ───────────────────────────────────────────────────────────────────
export const deleteIDMAccessCode = async (id) => {
  const options = requestOptionsForDELETE();
  return fetch(baseUrl + "idmaccesscodes/" + id, options).then(async (res) => {
    const body = await parseBody(res);
    if (!res.ok) return rejectWith(res, body);
    return body;
  });
};